(function () {
  function init(scope) {
    (scope || document).querySelectorAll('[data-aq24-product-story]').forEach(function(root) {
      if(root.dataset.ready) return; root.dataset.ready='1';
      root.querySelectorAll('[data-aq24-tabs]').forEach(function(feature) {
        var tabs=Array.from(feature.querySelectorAll('[class*="feature-tabs-icon-"]'));
        var panels=Array.from(feature.querySelectorAll('[class*="feature-text-content-"],[class*="feature-image-"]')).filter(x=>x.hasAttribute('data-id'));
        if(!tabs.length)return;
        var index=0, timer=null;
        function show(i) {
          index=(i+tabs.length)%tabs.length;
          tabs.forEach((t,n)=>{t.classList.toggle('static-active',n===index);t.classList.remove('active');t.setAttribute('aria-selected',String(n===index));t.tabIndex=n===index?0:-1;});
          panels.forEach(p=>{var active=p.dataset.id===tabs[index].id;p.classList.toggle('active',active);p.setAttribute('aria-hidden',String(!active));});
        }
        tabs.forEach((t,i)=>{
          t.setAttribute('role','tab');t.setAttribute('aria-label',t.innerText.trim()||(document.documentElement.lang==='ar'?'الميزة ':'Feature ')+(i+1));
          t.addEventListener('click',()=>{clearInterval(timer);show(i);});
          t.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight','Home','End','Enter',' '].indexOf(e.key)<0)return;e.preventDefault();clearInterval(timer);var n=e.key==='Home'?0:e.key==='End'?tabs.length-1:e.key==='ArrowLeft'?index-1:e.key==='ArrowRight'?index+1:i;show(n);tabs[index].focus();});
        });
        var list=tabs[0].parentElement;list.setAttribute('role','tablist');
        show(0);
        var observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{clearInterval(timer);if(entry.isIntersecting&&!matchMedia('(prefers-reduced-motion:reduce)').matches)timer=setInterval(()=>show(index+1),10000);});});observer.observe(feature);
      });
      root.querySelectorAll('[data-aq24-slideshow]').forEach(function(slider) {
        var slides=Array.from(slider.children).filter(x=>x.classList.contains('slideshow__slide'));if(slides.length<2)return;
        var index=0,controls=document.createElement('div');controls.className='aq24-slide-controls';
        function show(i){index=(i+slides.length)%slides.length;slides.forEach((s,n)=>{s.style.display=n===index?'block':'none';s.setAttribute('aria-hidden',String(n!==index));});}
        [-1,1].forEach(dir=>{var b=document.createElement('button');b.type='button';b.textContent=dir<0?'←':'→';b.setAttribute('aria-label',document.documentElement.lang==='ar'?(dir<0?'الشريحة السابقة':'الشريحة التالية'):(dir<0?'Previous slide':'Next slide'));b.addEventListener('click',()=>show(index+dir));controls.append(b);});
        slider.append(controls);show(0);
      });
      root.querySelectorAll('[data-spec-toggle],[data-accordion-trigger]').forEach(function(button){
        var content=button.hasAttribute('data-accordion-trigger')?root.querySelector('[id="'+button.getAttribute('aria-controls')+'"]'):button.nextElementSibling;
        if(!content)return;
        button.addEventListener('click',()=>{var open=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(open));content.style.display=open?'block':'none';content.style.height=open?'auto':'0';content.style.maxHeight=open?'none':'0';content.classList.toggle('is-expanded',open);});
      });
      root.querySelectorAll('[data-aq24-youtube], [data-aq24-media]').forEach(function(button) {
        var isArabic = document.documentElement.lang === 'ar';
        var id = button.getAttribute('data-aq24-youtube') || '';
        var source = button.getAttribute('data-aq24-media') || '';
        var videoUrl = null;
        try { if (source) videoUrl = new URL(source, window.location.href); } catch (error) { return; }
        var isFile = videoUrl && videoUrl.protocol === 'https:' && /\.mp4$/i.test(videoUrl.pathname);
        var isYouTube = /^[\w-]{11}$/.test(id);
        if (!isFile && !isYouTube) return;
        button.setAttribute('aria-haspopup', 'dialog');
        if (button.tagName === 'BUTTON') button.setAttribute('aria-label', isArabic ? 'تشغيل الفيديو' : 'Play video');
        button.addEventListener('click', function(event) {
          event.preventDefault();
          var modal = document.createElement('dialog');
          modal.className = 'aq24-video-dialog';
          modal.setAttribute('aria-label', isArabic ? 'فيديو Aqara' : 'Aqara video');
          var close = document.createElement('button');
          close.type = 'button'; close.textContent = '×';
          close.setAttribute('aria-label', isArabic ? 'إغلاق الفيديو' : 'Close video');
          var media = document.createElement(isFile ? 'video' : 'iframe');
          if (isFile) {
            media.src = videoUrl.href;
            media.controls = true; media.playsInline = true; media.autoplay = true;
            media.preload = 'metadata';
            media.setAttribute('aria-label', isArabic ? 'فيديو التركيب' : 'Installation video');
          } else {
            media.title = isArabic ? 'فيديو Aqara' : 'Aqara product video';
            media.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
            media.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
            media.referrerPolicy = 'strict-origin-when-cross-origin';
            media.allowFullscreen = true;
          }
          var fallback = document.createElement('a');
          fallback.className = 'aq24-video-direct'; fallback.target = '_blank'; fallback.rel = 'noopener';
          fallback.href = isFile ? videoUrl.href : 'https://www.youtube.com/watch?v=' + id;
          fallback.textContent = isArabic ? 'فتح الفيديو مباشرة' : 'Open video directly';
          var errorText = document.createElement('p');
          errorText.className = 'aq24-video-error'; errorText.hidden = true;
          errorText.setAttribute('role', 'status');
          errorText.textContent = isArabic ? 'تعذّر تحميل المشغّل. استخدم رابط الفيديو المباشر أدناه.' : 'The player could not load. Use the direct video link below.';
          media.addEventListener('error', function() { errorText.hidden = false; });
          modal.append(close, media, errorText, fallback); document.body.append(modal);
          close.addEventListener('click', function() { modal.close(); });
          modal.addEventListener('close', function() {
            if (isFile) { media.pause(); media.removeAttribute('src'); media.load(); }
            modal.remove(); button.focus();
          });
          modal.showModal(); close.focus();
          if (isFile) { var play = media.play(); if (play && play.catch) play.catch(function() {}); }
        });
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
